import { render, staticRenderFns } from "./ConfirmDetailsStep.vue?vue&type=template&id=2dfb608f&lang=pug"
import script from "./ConfirmDetailsStep.vue?vue&type=script&lang=js"
export * from "./ConfirmDetailsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Location: require('/home/docker/code/frontend/components/Location.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
